module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/262.36a24179.png";